import { ExternalApiLogFilter, ExternalApiLogList } from '../../../services/types/ExternalApiLog';
import { callService, serviceReducer } from '../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../types';

export type ExternalApiLogAction =
  | Action<ExternalApiLogList, ExternalApiLogFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'PAGE_SIZE'; value: number }
  | { type: 'FILTER'; includeSuccess: boolean };

const reducer = (
  state: ApiState<ExternalApiLogList, ExternalApiLogFilter>,
  action: ExternalApiLogAction
): ApiState<ExternalApiLogList, ExternalApiLogFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { pageNumber: action.value });
    case 'PAGE_SIZE':
      return callService(state, { pageSize: action.value });
    case 'FILTER':
      return callService(state, { includeSuccess: action.includeSuccess, pageNumber: 1 });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
